import styled from "styled-components";
import PhaseSixIcon from "../../phaseSixIcon/PhaseSixIcon";
import DesignConstants from "../../../constants/DesignConstants";

//TODO: use design constants when redesigning this part

export const CardWrapper = styled.div`
    width: 100%;
    // Indented so the card checkboxes sit visibly below the unit checkbox
    padding: 0.5em 1rem 0.5em 2.5rem;
    border-bottom: solid 2px ${DesignConstants.COLORS.BACKGROUND_LIGHT};
    background: white;
    display: flex;
    cursor: pointer;
`;

export const CheckboxWrapper = styled.div`
    margin: 0;
    width: 2rem;
    display: flex;
    align-items: center;
    justify-content: space-around;
`;

export const QuestionWrapper = styled.div`
    flex: 1;
    padding: 0 0.4rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
`;

export const AnswerWrapper = styled.div`
    flex: 1;
    padding: 0 0.4rem;
    font-size: 1rem;
    display: flex;
    align-items: center;
`;

export const QuestionAnswerWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-wrap: wrap;

    // Question and answer stack on small screens instead of squeezing into two columns
    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column;
        gap: ${DesignConstants.SPACES.XXS};
    }
`;

export const TextSpan = styled.span`
    font-size: inherit;

    &.checked {
        color: var(--creation-primary-color, #fc7c00);
    }
`;

export const GapSentenceWrapper = styled.div`
    padding: 0.5rem 0.4rem 0;
    width: 100%;
    font-size: 0.9rem;
`;

export const SmallP6Icon = styled(PhaseSixIcon)`
    font-size: 2rem;

    &.orange {
        color: var(--creation-primary-color, #fc7c00);
    }

    &.grey {
        color: ${DesignConstants.COLORS.MID_GREY};
    }
`;

export const CardAlreadyInUseIconWrapper = styled.div`
    position: relative;
    width: 2rem;
    height: 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
`;

export const AlreadyUsedTooltip = styled.span`
    display: none;
    position: absolute;
    right: 100%;
    top: 50%;
    transform: translateY(-50%);
    white-space: nowrap;
    background: ${DesignConstants.COLORS.WHITE};
    padding: ${DesignConstants.SPACES.XXS} ${DesignConstants.SPACES.XS};
    font-size: ${DesignConstants.FONT_SIZES.M};
    color: ${DesignConstants.COLORS.DARK_GREY};
    pointer-events: none;

    // Hover on desktop; on touch devices a tap applies :hover until the user taps elsewhere
    ${CardAlreadyInUseIconWrapper}:hover & {
        display: block;
    }

    // On small screens the text is wider than the row, so let it wrap instead of getting clipped
    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        white-space: normal;
        width: max-content;
        max-width: 60vw;
        text-align: right;
    }
`;
